import { render } from "./MusicFooter.vue?vue&type=template&id=090b1287"
import script from "./MusicFooter.vue?vue&type=script&lang=ts"
export * from "./MusicFooter.vue?vue&type=script&lang=ts"
script.render = render

export default script